import { emitSearchAssetsEvent } from '../helpers/emitSearchAssetsEvent';
import type { TextSearchParams } from '../helpers/types';
import { emitSimilaritySearchEvent } from '../NLSSearch/utils';

/** Context for AI: sticky-search ('singletext') bridge to paramount's filter bar — emits remove/reset events; sticky allows only one term at a time, so 'remove' needs no value. The 'legacy' dir is ported filterhelper.js glue; sticky itself is a current portal config, not deprecated. */
export function removeSingleTextFilter(isHybridSearchOn: boolean) {
	const filter: TextSearchParams = {
		disableModal: false,
		field: 'singletext',
		filterType: 'remove',
		value: '', // The searchTerm (aka value) is NOT needed. Sticky search (aka singletext search) only allows for one search term being applied at a time, so any request to 'remove' removes whichever was applied (if any)
	};

	emitSearchAssetsEvent(isHybridSearchOn, filter);
}

export function resetSimilarityFilters(isHybridSearchOn: boolean) {
	// We emit an event and AssetOverview in paramount handles the searching and removing from filterbar
	emitSimilaritySearchEvent(isHybridSearchOn, {
		similarToAssetIds: null,
		similarToImageData: null,
		similarToURL: null,
		similarToText: null,
	});
}
